import { ctaSchema } from './cta';
import headingSchema from './heading';
import { imageBackgroundSchema } from './images';
import mediaSchema from './media';
import subheadingSchema from './subheading';
import textSchema from './text';
import themeSchema from './theme';

const { alignment, ...mediaSchemaProps } = mediaSchema.properties;

const mediaSchemaWihoutAlignment = {
  ...mediaSchema,
  properties: mediaSchemaProps,
};

export const heroBannerSchema = {
  name: 'hero-banner',
  label: 'Hero Banner',
  editableProps: [
    headingSchema,
    subheadingSchema,
    textSchema,
    mediaSchemaWihoutAlignment,
    ctaSchema,
    imageBackgroundSchema,
    themeSchema,
  ],
};
